import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=bb41d33a&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=bb41d33a&prod&lang=css"
import style1 from "./Result.vue?vue&type=style&index=1&id=bb41d33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb41d33a",
  null
  
)

export default component.exports